export default __webpack_public_path__ + "static/media/36.7294e653.png";